/* eslint-disable spire/export-styles */
import RequestQuoteModal from "@flip/App/Components/Common/RequestQuoteModal";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import * as React from "react";

interface OwnProps {
    skipInventoryValidation?: boolean;
}

type Props = OwnProps;

// XNG-Changes: add RequestQuoteModal
const Modals = ({ skipInventoryValidation }: Props) => (
    <>
        <AddToListModal />
        <ShareListModal />
        <ManageShareListModal />
        <ShareListDetailModal />
        <ProductSelectorVariantModal skipInventoryValidation={skipInventoryValidation} />
        <ProductDeliveryScheduleModal />
        <RequestQuoteModal />
    </>
);

export default Modals;
